import { render, staticRenderFns } from "./individualAnalysis.vue?vue&type=template&id=708b5504&scoped=true&"
import script from "./individualAnalysis.vue?vue&type=script&lang=js&"
export * from "./individualAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./individualAnalysis.vue?vue&type=style&index=0&id=708b5504&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708b5504",
  null
  
)

export default component.exports